import React, { PureComponent } from "react";
import { Modal, Button } from "react-bootstrap";
import { detectMobile } from "services/utils";

class LastStepModal extends PureComponent {
  render() {
    const isMobile = detectMobile();
    const { location, router, url } = this.props;
    const isShown = location.query.from === 'get-started' || false;

    return (
      <Modal
        show={isShown}
        onHide={() => {}}
        dialogClassName="getStarterModal getStartedModalSmall feedback-modal"
        backdrop="static"
        backdropClassName="feedback-backdrop"
      >
        <Modal.Body>
          <br />
          <p className="steps__text">
            This is the page where you’ll make your decisions for this round.
          </p>
          <p className="steps__text">
            To get started on this exercise, please click on the red “Explainer”
            button after you’ve clicked on the Close” button below.
          </p>
          <div className="feedback-button">
            <Button
              bsStyle="primary"
              bsSize={isMobile === true ? "md" : "lg"}
              onClick={() => { router.push(url); }}
            >
              Close
              <span />
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

export default LastStepModal;



// WEBPACK FOOTER //
// ./src/components/get-started/last-step.js